import React from "react"
import "./floatingButton.scss"

const FloatingButton = (props: FloatingButtonInterface) => {

   const {
      url,
      icon
   } = props

   const handleClick = (e) => {
      e.preventDefault();
      window.open(url, 'mywindow');
   }

   return (
      <div className="a-floating__button" onClick={handleClick}>
         <img src={icon} alt='centro-de-atencion' />
      </div>
   )
}

interface FloatingButtonInterface {
   url: string | any;
   icon: string;
}

export default FloatingButton